"use client";

import ErrorComponent from "@/components/errorBoundary/ErrorComponent";
import StoreProvider from "./StoreProvider";
import ThemeClient from "./ThemeClient";

export default function GlobalError() {
  return (
    <html>
      <body>
        {/* global-error replaces the root layout, so it needs its own store */}
        <StoreProvider>
          <ThemeClient>
            <ErrorComponent />
          </ThemeClient>
        </StoreProvider>
      </body>
    </html>
  );
}
